export default "__VITE_ASSET__a6687e1c__"